<script>
  export let classList = '';
</script>

<footer class={classList}>
  <ul>
    <slot></slot>
  </ul>
</footer>

<style>
  footer {
    padding-left: 1rem;
  }
  footer ul :global(li)::before {
    content: '• ';
    color: var(--c-text);
    font-size: 1.6rem;
    margin-right: 0.3rem;
    margin-left: -0.5rem;
    padding-left: 0.5em;
  }
  footer ul :global(li:last-of-type)::before {
    content: '☞ ';
    color: var(--c-text);
    margin-right: -0.1rem;
    margin-left: -1rem;
    padding-left: 0.5em;
  }
  footer :global(small) {
    color: var(--c-text);
  }
  footer :global(a) {
    color: var(--c-accent);
  }
  footer :global(a):hover {
    color: var(--c-text);
  }
</style>
